import {
  useContext,
  useEffect,
  useReducer,
  useState,
  createContext,
} from "react";
import { getLessonsFromAPI } from "../../common/service/service";
import { config } from "../../common/utilites/config";
import {
  getLessonsFromLocalStorage,
  isOneHourLate,
  saveLessonsToLocalStorage,
} from "../../common/utilites/utilities";
import {
  CONTINUE_ITEM,
  RESET,
  SET_CORRECT_ANSWER,
  SET_IS_DISABLED,
  SET_LESSONS,
  SET_NET,
  SET_WRONG_ANSWER,
  TOGGLE_ITEM,
} from "./types";

const defaultValue = getLessonsFromLocalStorage(config.keyOfLGS) || [];

export const AppContext = createContext(defaultValue);
export const useAppContext = () => useContext(AppContext);

export function AppContextProvider({ children }: any) {
  const [initialState, setInitialState] = useState(defaultValue);
  const [lessonsLoading, setLessonsLoading] = useState(false);
  const [calculateLoading, setCalculateLoading] = useState(false);
  const [error, setError] = useState(false);
  const [examScore, setExamScore] = useState(Number(0).toFixed(2));

  useEffect(() => {
    if (!initialState.length || isOneHourLate(config.keyOfLGS)) {
      setLessonsLoading(true);
      getLessonsFromAPI("lgs")
        .then(({ results }) => {
          results.forEach((item: any, index: any) => {
            item.isOpen = index === 0;
            item.wrong = 0;
            item.correct = 0;
            item.net = Number(0).toFixed(2);
          });
          setInitialState(results);
          setError(false);
          saveLessonsToLocalStorage(results, config.keyOfLGS);
          dispatch({
            type: SET_LESSONS,
            payload: results,
          });
        })
        .catch(() => setError(true))
        .finally(() => setLessonsLoading(false));
    }
  }, [initialState]);

  useEffect(() => {
    if (error) {
      alert("Bir hata oluştu daha sonra tekrar deneyiniz.");
    }
  }, [error]);

  const reducer = (state: any, action: any) => {
    switch (action.type) {
      case SET_LESSONS: {
        const newState = [...action.payload];

        return newState;
      }
      case SET_NET: {
        const newState = state.map((item: any) => {
          if (item.id === action.payload.id) {
            return { ...item, net: action.payload.net };
          }

          return item;
        });

        return newState;
      }
      case SET_CORRECT_ANSWER: {
        const newState = state.map((item: any) => {
          if (item.id === action.payload.id) {
            return { ...item, correct: action.payload.correct };
          }

          return item;
        });

        return newState;
      }
      case SET_WRONG_ANSWER: {
        const newState = state.map((item: any) => {
          if (item.id === action.payload.id) {
            return { ...item, wrong: action.payload.wrong };
          }

          return item;
        });

        return newState;
      }
      case SET_IS_DISABLED: {
        const newState = state.map((item: any) => {
          if (item.id === action.payload.id) {
            return {
              ...item,
              net: Number(0).toFixed(2),
              correct: 0,
              wrong: 0,
              isDisabled: action.payload.isExempt,
            };
          }

          return item;
        });

        return newState;
      }
      case TOGGLE_ITEM: {
        const newState = state.map((item: any) => {
          if (item.id === action.payload.id) {
            return {
              ...item,
              isOpen: action.payload.isOpen,
            };
          }

          return {
            ...item,
            isOpen: false,
          };
        });

        return newState;
      }
      case CONTINUE_ITEM: {
        const newState = state.map((item: any, index: any) => {
          if (index === action.payload.index) {
            return {
              ...item,
              isOpen: true,
            };
          }

          return {
            ...item,
            isOpen: false,
          };
        });

        return newState;
      }
      case RESET: {
        return initialState;
      }
      default:
        return state;
    }
  };

  const [state, dispatch] = useReducer(reducer, initialState);

  const contextValue = {
    state,
    dispatch,
    lessonsLoading,
    calculateLoading,
    setCalculateLoading,
    setError,
    examScore,
    setExamScore,
  };

  return (
    <AppContext.Provider value={contextValue}>{children}</AppContext.Provider>
  );
}
